/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shifts_CreateTemplateRequest } from '../models/shifts_CreateTemplateRequest';
import type { shifts_TemplateListResponse } from '../models/shifts_TemplateListResponse';
import type { shifts_TemplateResponse } from '../models/shifts_TemplateResponse';
import type { shifts_UpdateTemplateRequest } from '../models/shifts_UpdateTemplateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftTemplatesService {
    /**
     * List shift templates
     * Get paginated list of shift templates
     * @param limit Items per page
     * @param offset Offset for pagination
     * @returns shifts_TemplateListResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftTemplates(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<shifts_TemplateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shift-templates',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list templates`,
            },
        });
    }
    /**
     * Create a new shift template
     * Create a new reusable shift template
     * @param request Template to create
     * @returns shifts_TemplateResponse Created
     * @throws ApiError
     */
    public static postApiV1ShiftTemplates(
        request: shifts_CreateTemplateRequest,
    ): CancelablePromise<shifts_TemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shift-templates',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to create template`,
            },
        });
    }
    /**
     * Delete shift template
     * Soft delete a shift template
     * @param id Template ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ShiftTemplates(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/shift-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing template ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Template not found`,
                500: `Failed to delete template`,
            },
        });
    }
    /**
     * Get shift template by ID
     * Get a single shift template by ID
     * @param id Template ID
     * @returns shifts_TemplateResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftTemplates1(
        id: string,
    ): CancelablePromise<shifts_TemplateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shift-templates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing template ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Template not found`,
                500: `Failed to get template`,
            },
        });
    }
    /**
     * Update shift template
     * Update an existing shift template with optimistic locking
     * @param id Template ID
     * @param request Updated template data
     * @returns shifts_TemplateResponse OK
     * @throws ApiError
     */
    public static putApiV1ShiftTemplates(
        id: string,
        request: shifts_UpdateTemplateRequest,
    ): CancelablePromise<shifts_TemplateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/shift-templates/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Template not found`,
                409: `Template was modified by another user`,
                500: `Failed to update template`,
            },
        });
    }
}
